import React, { useEffect, useRef, useState } from 'react';
import { Image, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import InfoBtn from '../../images/info-btn.svg';
import NasiontoInionModal from './NasiontoInionModal';
import PreauricularModal from './PreauricularModal';
import CircumferenceModal from './CircumferenceModal';
import { toast } from 'react-toastify';
import { useReactToPrint } from "react-to-print";
import PrintResults from './PrintResults';

const fieldConfig = [
  {
    id: 'nasionToInion',
    label: 'Nasion to Inion distance',
    placeholder: '--',
    unit: 'cm',
    defaultValue: '35',
    Modal: NasiontoInionModal,
  },
  {
    id: 'preauricular',
    label: 'Preauricular to Preauricular distance',
    placeholder: '--',
    unit: 'cm',
    defaultValue: '35',
    Modal: PreauricularModal,
  },
  {
    id: 'circumference',
    label: 'Circumference',
    placeholder: '--',
    unit: 'cm',
    defaultValue: '35',
    Modal: CircumferenceModal,
  },
];

const FormCard = ({ onFormSubmit, formData, onReset, isResultGenerated }) => {
  const componentRef = useRef(null);

  const [localFormData, setLocalFormData] = useState({
    nasionToInion: formData.nasionToInion || '',
    preauricular: formData.preauricular || '',
    circumference: formData.circumference || '',
    nomenclature: formData.nomenclature || 'T3/T4',
  });
  const [activeModal, setActiveModal] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();

  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
  };

  const handleChange = (id, value) => {
    setLocalFormData({ ...localFormData, [id]: value });
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const resetForm = () => {
    const currentNomenclature = localFormData.nomenclature;
    setLocalFormData({
      nasionToInion: '',
      preauricular: '',
      circumference: '',
      nomenclature: currentNomenclature,
    });
    onReset({ nasionToInion: '', preauricular: '', circumference: '', nomenclature: currentNomenclature });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success('Result Generated Successfully!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    onFormSubmit(localFormData);
  };

  const handlePrint = () => {
    toast('📄 Tip: Wait for a clean PDF.', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    // setTimeout(() => window.print(), 100);
    setTimeout(() => {
      printFn();
    }, 200); // enou
  };
  const printFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "10‑20 Measurement Results",
  });

  return (
    <div className="login-box homepage-form">
      <div className="head-info">
        <p>
          After generating results you can click “Print Results” to print or save a copy for future use for this patient
        </p>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="ifu-tooltip">Click on this text link to view instructions</Tooltip>}
        >
          {({ ref, ...triggerHandler }) => (
            <a
              href="https://ez1020.com/pages/ifu"
              target="_blank"
              rel="noopener noreferrer"
              className="forgot-password mt-2 d-inline-flex align-items-center"
              {...triggerHandler}
            >
              <Image ref={ref} src={InfoBtn} alt="info" className="me-1" />
              <span>Instructions for Use</span>
            </a>
          )}
        </OverlayTrigger>
      </div>
      <form onSubmit={handleSubmit}>
        {fieldConfig.map(({ id, label, placeholder, unit, Modal }) => (
          <div className="form-field" key={id}>
            <div className="label-part d-flex align-items-center w-100 justify-content-between">
              <label htmlFor={id} className="w-100">
                {label}
              </label>
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveModal(id);
                }}
              >
                <Image src={InfoBtn} alt="info" />
              </Link>
            </div>
            <div className="distance-input position-relative d-flex align-items-center w-100">
              <input
                type="text"
                id={id}
                autoComplete='off'
                className="input-field active-input"
                placeholder={placeholder}
                value={localFormData[id] || ''}
                onChange={(e) => handleChange(id, e.target.value)}
                required
              />
              <span className="unit-label">{unit}</span>
            </div>
            {activeModal === id && (
              <Modal showModal={true} onClose={() => setActiveModal(null)} />
            )}
          </div>
        ))}
        <div className="form-field" ref={dropdownRef}>
          <label>Preferred Nomenclature</label>
          <div className="custom-dropdown dropdown w-100 position-relative">
            <div
              className="dropdown-toggle form-like-dropdown d-flex align-items-center justify-content-between"
              onClick={() => setDropdownOpen(!dropdownOpen)}
              style={{ cursor: 'pointer' }}
            >
              {localFormData.nomenclature}
              <span className="custom-dropdown-arrow">
                <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M12.8334 1.5L7.00008 6.5L1.16675 1.5"
                    stroke="#838383"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </div>
            {dropdownOpen && (
              <ul className="dropdown-menu w-100 show" style={{ display: 'block', position: 'absolute', zIndex: 99 }}>
                {['T3/T4', 'T7/T8'].map((item) => (
                  <li key={item}>
                    <a
                      className="dropdown-item"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setLocalFormData({ ...localFormData, nomenclature: item });
                        setDropdownOpen(false);
                      }}
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
        <div className="form-footer mt-0">
          <button
            type="submit"
            className="login-button btn-blue"
            onClick={(e) => {
              if (isResultGenerated) {
                e.preventDefault();
                handlePrint();
              }
              // otherwise normal form submit will handle "Generate Result"
            }}
          >
            {isResultGenerated ? 'Print Results' : 'Generate Results'}
          </button>
        </div>
        <button
          type="button"
          className="login-button btn-blue mt-2"
          onClick={resetForm}
        >
          New Patient
        </button>

      </form>
      <div style={{ display: "none" }}>
        <PrintResults
          ref={componentRef}
          formData={formData.formData || {}}
          calculatedValues={formData.calculatedValues || {}}
          timestamp={formData.timestamp || ''}
        />
      </div>
    </div>
  );
};

export default FormCard;